import { render, staticRenderFns } from "./DashTilesClaude.vue?vue&type=template&id=37eb469e&scoped=true"
import script from "./DashTilesClaude.vue?vue&type=script&lang=js"
export * from "./DashTilesClaude.vue?vue&type=script&lang=js"
import style0 from "./DashTilesClaude.vue?vue&type=style&index=0&id=37eb469e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37eb469e",
  null
  
)

export default component.exports